/*
 * Lista de deseos basada en localStorage (sin cuenta de cliente ni app externa).
 * Guarda los "handles" de producto en el navegador del visitante.
 */
(function () {
  var STORAGE_KEY = 'star-style-wishlist';

  function getAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function save(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      /* localStorage no disponible (modo privado, cuota llena, etc.) */
    }
  }

  function has(handle) {
    return getAll().indexOf(handle) > -1;
  }

  function toggle(handle) {
    var handles = getAll();
    var index = handles.indexOf(handle);
    if (index > -1) {
      handles.splice(index, 1);
    } else {
      handles.push(handle);
    }
    save(handles);
    notify();
    return handles.indexOf(handle) > -1;
  }

  function remove(handle) {
    save(getAll().filter(function (item) {
      return item !== handle;
    }));
    notify();
  }

  function count() {
    return getAll().length;
  }

  function notify() {
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: count() } }));
  }

  window.Wishlist = {
    getAll: getAll,
    has: has,
    toggle: toggle,
    remove: remove,
    count: count
  };

  function syncButtonState(button) {
    var handle = button.getAttribute('data-wishlist-toggle');
    var active = has(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButtonState);
  }

  function updateCountBadges(currentCount) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = currentCount;
      var bubble = el.closest('.wishlist-count-bubble');
      if (bubble) bubble.style.display = currentCount > 0 ? '' : 'none';
    });
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var emptyState = document.querySelector('[data-wishlist-empty]');
    var handles = getAll();

    if (handles.length === 0) {
      grid.hidden = true;
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          var item = document.createElement('div');
          item.className = 'wishlist-page__item';
          item.innerHTML =
            '<a href="' + product.url + '">' +
              (product.featured_image ? '<img src="' + product.featured_image + '&width=533" alt="' + product.title.replace(/"/g, '&quot;') + '" width="533" loading="lazy">' : '') +
              '<p class="card-information__text h5">' + product.title + '</p>' +
              '<p class="price">' + (product.price / 100).toLocaleString('es-CO', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'COP' }) + '</p>' +
            '</a>' +
            '<button type="button" class="wishlist-page__remove" data-wishlist-remove="' + handle + '">Quitar</button>';
          grid.appendChild(item);
        })
        .catch(function () {
          /* producto eliminado o no disponible; se omite de la lista */
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAllButtons();
    updateCountBadges(count());
    renderWishlistPage();
  });

  document.addEventListener('wishlist:updated', function (event) {
    syncAllButtons();
    updateCountBadges(event.detail.count);
    renderWishlistPage();
  });

  document.body.addEventListener('click', function (event) {
    var toggleButton = event.target.closest('[data-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      toggle(toggleButton.getAttribute('data-wishlist-toggle'));
      return;
    }

    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      remove(removeButton.getAttribute('data-wishlist-remove'));
    }
  });
})();
